import React from "react";
import { Outlet } from "react-router-dom";

const Settings: React.FC = () => {
    return <Outlet />;
};

export default Settings;
